import { takeEvery, put, call, fork } from "redux-saga/effects";
import { v4 as uuidv4 } from "uuid";

import { Client } from "../../utils/client";
import { RECORD_LOAD, recordLoadSuccess, RECORDED_DELETE, RECORDED_ADD, RECORDED_REMOVE, RECORDED_REFRESH, recordActionSuccess, recordActionError, RECORDED_GET, recordGetSuccess, RECORDED_EPG_GET } from "./actions";
import { setError } from "../../redux-root/actions";

export function* recordLoad() {
  try {
    const planData = yield call(Client.getData, '/dvr/plan', '2');
    let scheduleData = {
      data: []
    };

    if (planData && planData.data && planData.data.accountNo) {
      scheduleData = yield call(Client.getData, '/dvr/schedules?offset=0&limit=1000', '2');
    }

    yield put(recordLoadSuccess(planData.data, scheduleData.data));
  } catch (error) {
    console.log(error);

    yield put(setError('General Errors', `It's not you. It's us. We are working to fix this...`, error));
  }
}

export function* recordedDelete(action) {
  const { payload } = action;

  try {
    const recordRequest = {
      requestId: uuidv4(),
      timeSlotId: payload,
    };
    
    yield call(Client.deleteData, '/dvr/schedules', recordRequest, '2');
    const scheduleData = yield call(Client.getData, '/dvr/schedules?offset=0&limit=1000', '2');

    yield put(recordActionSuccess(scheduleData.data));
  } catch (error) {
    console.log(error);

    let errMsg = '';

    if (error.data && error.data.title) {
      errMsg = error.data.title;
    }

    yield put(recordActionError(errMsg));
  }
}

export function* recordedAdd(action) {
  const { payload, url } = action;

  try {
    const recordRequest = {
      requestId: uuidv4(),
      timeSlotId: payload,
    };
    
    yield call(Client.postData, `/dvr/schedules/${url}`, recordRequest, '2');
    const scheduleData = yield call(Client.getData, '/dvr/schedules?offset=0&limit=1000', '2');

    yield put(recordActionSuccess(scheduleData.data));
  } catch (error) {
    console.log(error);

    let errMsg = '';

    if (error.data && error.data.title) {
      errMsg = error.data.title;
    }

    yield put(recordActionError(errMsg));
  }
}

export function* recordedRemove(action) {
  const { payload, url } = action;

  try {
    const recordRequest = {
      requestId: uuidv4(),
      timeSlotId: payload,
    };
    
    yield call(Client.putData, `/dvr/schedules/${url}`, recordRequest, '2');
    const scheduleData = yield call(Client.getData, '/dvr/schedules?offset=0&limit=1000', '2');

    yield put(recordActionSuccess(scheduleData.data));
  } catch (error) {
    console.log(error);

    let errMsg = '';

    if (error.data && error.data.title) {
      errMsg = error.data.title;
    }

    yield put(recordActionError(errMsg));
  }
}

export function* recordedRefresh() {
  try {
    const scheduleData = yield call(Client.getData, '/dvr/schedules?offset=0&limit=1000', '2');

    yield put(recordActionSuccess(scheduleData.data));
  } catch (error) {
    console.log(error);

    let errMsg = '';

    if (error.data && error.data.title) {
      errMsg = error.data.title;
    }

    yield put(recordActionError(errMsg));
  }
}

export function* recordedGet(action) {
  const { payload } = action;

  try {
    const recordedData = yield call(Client.getData, `/dvr/schedules/timeslots/${payload}`, '2');
    const scheduleData = yield call(Client.getData, '/dvr/schedules?offset=0&limit=1000', '2');

    yield put(recordGetSuccess(recordedData.data, scheduleData.data));
  } catch (error) {
    console.log(error);
  }
}

export function* recordedEpgGet(action) {
  const { payload } = action;

  try {
    const epgData = yield call(Client.getData, `/channels/epg/schedule/${payload}`);
    const scheduleData = yield call(Client.getData, '/dvr/schedules?offset=0&limit=1000', '2');

    let recordedData = {
      data: []
    };

    if (epgData.data && epgData.data.timeSlotId) {
      recordedData = yield call(Client.getData, `/dvr/schedules/timeslots/${epgData.data.timeSlotId}`, '2');
    }
    
    yield put(recordGetSuccess(recordedData.data, scheduleData.data, epgData.data));
  } catch (error) {
    console.log(error);
  }
}


function* watchRecordLoad() {
  yield takeEvery(RECORD_LOAD, recordLoad);
}

function* watchRecordedDelete() {
  yield takeEvery(RECORDED_DELETE, recordedDelete);
}

function* watchRecordedAdd() {
  yield takeEvery(RECORDED_ADD, recordedAdd);
}

function* watchRecordedRemove() {
  yield takeEvery(RECORDED_REMOVE, recordedRemove);
}

function* watchRecordedRefresh() {
  yield takeEvery(RECORDED_REFRESH, recordedRefresh);
}

function* watchRecordedGet() {
  yield takeEvery(RECORDED_GET, recordedGet);
}

function* watchRecordedEpgGet() {
  yield takeEvery(RECORDED_EPG_GET, recordedEpgGet);
}

export function* recordSaga() {
  yield fork(watchRecordLoad);
  yield fork(watchRecordedDelete);
  yield fork(watchRecordedAdd);
  yield fork(watchRecordedRemove);
  yield fork(watchRecordedRefresh);
  yield fork(watchRecordedGet);
  yield fork(watchRecordedEpgGet);
}
